module.exports = __webpack_public_path__ + "img/image06.2267255c.jpg";